import React from "react"

const Subtitle = ({ children }) => (
  <h3 className="uppercase font-bold text-xl text-gray-600 tracking-widest mb-4">
    {children}
  </h3>
)

export default Subtitle
